const pages = "/auth/"

export const UPDATE_AUTH_DATA = `${pages}UPDATE_AUTH_DATA`;
export const RESET = `${pages}RESET`;
export const UPDATE_REDUCER = `${pages}UPDATE_REDUCER`;

